export default __webpack_public_path__ + "static/bg-ford--mobile-b81e9d6162c39fc539b6d568885135b6.webp";